// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__LeF6U","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__UKip6"};